const formatSecondsToTime = (timeInSeconds) => {
  const totalSeconds = Math.floor(timeInSeconds),
    seconds = Math.floor(timeInSeconds % 60),
    minutes = Math.floor((timeInSeconds / 60) % 60),
    hours = Math.floor(timeInSeconds / (60 * 60))

  const hasHours = hours > 0
  const hasMinutes = minutes > 0

  const value =
    (hasHours ? hours + 'h' : '') +
    (hasMinutes ? (hasHours ? ' ' : '') + minutes + 'm' : '') +
    (totalSeconds < 60
      ? (hasHours || hasMinutes ? ' ' : '') + seconds + 's'
      : '')
  return value
}

export const useTimeDisplay = (timeInSeconds) => {
  const formattedValue = formatSecondsToTime(timeInSeconds)

  return {
    formattedValue,
  }
}
